<div class="checkbox-input">
  <mat-checkbox [formControl]="control" [color]="color">
    {{ label }}
  </mat-checkbox>
</div>
